var cov_mo8t28n3k = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Select/OptionTree.tsx",
      hash = "22ffdf0ae04c4e236ff1a718409f2ad1d2163c18",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Select/OptionTree.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 18
        },
        end: {
          line: 11,
          column: 51
        }
      },
      "1": {
        start: {
          line: 12,
          column: 22
        },
        end: {
          line: 12,
          column: 29
        }
      },
      "2": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 16
        }
      },
      "3": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 50
        }
      },
      "4": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 70
        }
      },
      "5": {
        start: {
          line: 26,
          column: 21
        },
        end: {
          line: 26,
          column: 22
        }
      },
      "6": {
        start: {
          line: 27,
          column: 32
        },
        end: {
          line: 27,
          column: 42
        }
      },
      "7": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 36
        }
      },
      "8": {
        start: {
          line: 28,
          column: 30
        },
        end: {
          line: 28,
          column: 36
        }
      },
      "9": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 54
        }
      },
      "10": {
        start: {
          line: 33,
          column: 34
        },
        end: {
          line: 33,
          column: 44
        }
      },
      "11": {
        start: {
          line: 34,
          column: 20
        },
        end: {
          line: 34,
          column: 36
        }
      },
      "12": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 46,
          column: 5
        }
      },
      "13": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 63,
          column: 18
        }
      },
      "14": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 69,
          column: 7
        }
      },
      "15": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 69,
          column: 7
        }
      },
      "16": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 71,
          column: 116
        }
      },
      "17": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 116
        }
      },
      "18": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 90,
          column: 5
        }
      },
      "19": {
        start: {
          line: 94,
          column: 96
        },
        end: {
          line: 94,
          column: 106
        }
      },
      "20": {
        start: {
          line: 95,
          column: 23
        },
        end: {
          line: 95,
          column: 89
        }
      },
      "21": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 100,
          column: 23
        }
      },
      "22": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 112,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 51
          },
          end: {
            line: 19,
            column: 3
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        loc: {
          start: {
            line: 21,
            column: 25
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 21
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 55
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 25
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 32
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        loc: {
          start: {
            line: 49,
            column: 15
          },
          end: {
            line: 91,
            column: 3
          }
        },
        line: 49
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 3
          }
        },
        loc: {
          start: {
            line: 93,
            column: 11
          },
          end: {
            line: 113,
            column: 3
          }
        },
        line: 93
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 22,
            column: 11
          },
          end: {
            line: 22,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 12
          },
          end: {
            line: 22,
            column: 27
          }
        }, {
          start: {
            line: 22,
            column: 31
          },
          end: {
            line: 22,
            column: 51
          }
        }, {
          start: {
            line: 22,
            column: 56
          },
          end: {
            line: 22,
            column: 70
          }
        }],
        line: 22
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 36
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 36
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 37,
            column: 15
          },
          end: {
            line: 37,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 37,
            column: 45
          },
          end: {
            line: 37,
            column: 52
          }
        }, {
          start: {
            line: 37,
            column: 55
          },
          end: {
            line: 37,
            column: 64
          }
        }],
        line: 37
      },
      "3": {
        loc: {
          start: {
            line: 40,
            column: 10
          },
          end: {
            line: 40,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 10
          },
          end: {
            line: 40,
            column: 27
          }
        }, {
          start: {
            line: 40,
            column: 31
          },
          end: {
            line: 40,
            column: 41
          }
        }],
        line: 40
      },
      "4": {
        loc: {
          start: {
            line: 41,
            column: 10
          },
          end: {
            line: 41,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 10
          },
          end: {
            line: 41,
            column: 30
          }
        }, {
          start: {
            line: 41,
            column: 34
          },
          end: {
            line: 41,
            column: 63
          }
        }],
        line: 41
      },
      "5": {
        loc: {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 69,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 69,
            column: 7
          }
        }, {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 69,
            column: 7
          }
        }],
        line: 64
      },
      "6": {
        loc: {
          start: {
            line: 67,
            column: 11
          },
          end: {
            line: 67,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 42
          },
          end: {
            line: 67,
            column: 60
          }
        }, {
          start: {
            line: 67,
            column: 63
          },
          end: {
            line: 67,
            column: 70
          }
        }],
        line: 67
      },
      "7": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 71,
            column: 116
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 71,
            column: 116
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 71,
            column: 116
          }
        }],
        line: 70
      },
      "8": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 29
          }
        }, {
          start: {
            line: 70,
            column: 33
          },
          end: {
            line: 70,
            column: 46
          }
        }],
        line: 70
      },
      "9": {
        loc: {
          start: {
            line: 71,
            column: 73
          },
          end: {
            line: 71,
            column: 108
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 73
          },
          end: {
            line: 71,
            column: 82
          }
        }, {
          start: {
            line: 71,
            column: 86
          },
          end: {
            line: 71,
            column: 108
          }
        }],
        line: 71
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Select/OptionTree.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import { getDirectionClass } from '../utils/classname';
import List from '../AnimationList';
import Tree from '../Tree';
import Spin from '../Spin';
import { getLocale } from '../locale';
import { selectClass } from './styles';
import { getCustomList } from './utils';
var ScaleList = (cov_mo8t28n3k.s[0]++, List(['fade', 'scale-y'], 'fast'));
var DATA_PATH_KEY = (cov_mo8t28n3k.s[1]++, '$PATH');

var OptionList =
/*#__PURE__*/
function (_Component) {
  _inherits(OptionList, _Component);

  var _super = _createSuper2(OptionList);

  function OptionList(props) {
    var _this;

    _classCallCheck(this, OptionList);

    cov_mo8t28n3k.f[0]++;
    cov_mo8t28n3k.s[2]++;
    _this = _super.call(this, props);
    cov_mo8t28n3k.s[3]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OptionList, [{
    key: "getText",
    value: function getText(key) {
      cov_mo8t28n3k.f[1]++;
      cov_mo8t28n3k.s[4]++;
      return (cov_mo8t28n3k.b[0][0]++, this.props.text) && (cov_mo8t28n3k.b[0][1]++, this.props.text[key]) || (cov_mo8t28n3k.b[0][2]++, getLocale(key));
    }
  }, {
    key: "handleClick",
    value: function handleClick(data, _, p) {
      cov_mo8t28n3k.f[2]++;

      var _ref = (cov_mo8t28n3k.s[5]++, p),
          path = _ref.path;

      var _ref2 = (cov_mo8t28n3k.s[6]++, this.props),
          datum = _ref2.datum,
          onChange = _ref2.onChange;

      cov_mo8t28n3k.s[7]++;

      if (datum.disabled(data)) {
        cov_mo8t28n3k.b[1][0]++;
        cov_mo8t28n3k.s[8]++;
        return;
      } else {
        cov_mo8t28n3k.b[1][1]++;
      }

      cov_mo8t28n3k.s[9]++;
      onChange(null, _objectSpread2(_objectSpread2({}, data), {}, _defineProperty({}, DATA_PATH_KEY, path)));
    }
  }, {
    key: "renderItem",
    value: function renderItem(data) {
      cov_mo8t28n3k.f[3]++;

      var _ref3 = (cov_mo8t28n3k.s[10]++, this.props),
          renderItem = _ref3.renderItem,
          datum = _ref3.datum;

      var content = (cov_mo8t28n3k.s[11]++, renderItem(data));
      cov_mo8t28n3k.s[12]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          title: typeof content === 'string' ? (cov_mo8t28n3k.b[2][0]++, content) : (cov_mo8t28n3k.b[2][1]++, undefined),
          className: selectClass('tree-node', (cov_mo8t28n3k.b[3][0]++, datum.check(data)) && (cov_mo8t28n3k.b[3][1]++, 'selected'), (cov_mo8t28n3k.b[4][0]++, datum.disabled(data)) && (cov_mo8t28n3k.b[4][1]++, getDirectionClass('disabled'))),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 36,
            columnNumber: 7
          }
        }, content)
      );
    }
  }, {
    key: "renderTree",
    value: function renderTree() {
      cov_mo8t28n3k.f[4]++;

      var _ref4 = (cov_mo8t28n3k.s[13]++, this.props),
          loading = _ref4.loading,
          treeData = _ref4.treeData,
          keygen = _ref4.keygen,
          onExpand = _ref4.onExpand,
          loader = _ref4.loader,
          expanded = _ref4.expanded,
          defaultExpanded = _ref4.defaultExpanded,
          defaultExpandAll = _ref4.defaultExpandAll,
          renderPending = _ref4.renderPending,
          childrenKey = _ref4.childrenKey,
          expandIcons = _ref4.expandIcons,
          emptyText = _ref4.emptyText;

      cov_mo8t28n3k.s[14]++;

      if (loading) {
        cov_mo8t28n3k.b[5][0]++;
        cov_mo8t28n3k.s[15]++;
        return (
          /*#__PURE__*/
          React.createElement("span", {
            className: selectClass(getDirectionClass('option')),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 66,
              columnNumber: 9
            }
          }, typeof loading === 'boolean' ? (cov_mo8t28n3k.b[6][0]++,
          /*#__PURE__*/
          React.createElement(Spin, {
            size: 20,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 67,
              columnNumber: 43
            }
          })) : (cov_mo8t28n3k.b[6][1]++, loading))
        );
      } else {
        cov_mo8t28n3k.b[5][1]++;
      }

      cov_mo8t28n3k.s[16]++;

      if ((cov_mo8t28n3k.b[8][0]++, treeData.length === 0) || (cov_mo8t28n3k.b[8][1]++, renderPending)) {
        cov_mo8t28n3k.b[7][0]++;
        cov_mo8t28n3k.s[17]++;
        return (
          /*#__PURE__*/
          React.createElement("span", {
            className: selectClass(getDirectionClass('option')),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 71,
              columnNumber: 14
            }
          }, (cov_mo8t28n3k.b[9][0]++, emptyText) || (cov_mo8t28n3k.b[9][1]++, this.getText('noData')))
        );
      } else {
        cov_mo8t28n3k.b[7][1]++;
      }

      cov_mo8t28n3k.s[18]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: selectClass('tree-wrapper'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 73,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Tree, {
          radioUpdate: true,
          onClick: this.handleClick,
          line: false,
          data: treeData,
          keygen: keygen,
          renderItem: this.renderItem.bind(this),
          onExpand: onExpand,
          loader: loader,
          expanded: expanded,
          defaultExpandAll: defaultExpandAll,
          defaultExpanded: defaultExpanded,
          childrenKey: childrenKey,
          expandIcons: expandIcons,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 74,
            columnNumber: 9
          }
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_mo8t28n3k.f[5]++;

      var _ref5 = (cov_mo8t28n3k.s[19]++, this.props),
          focus = _ref5.focus,
          style = _ref5.style,
          selectId = _ref5.selectId,
          height = _ref5.height,
          getRef = _ref5.getRef,
          customHeader = _ref5.customHeader,
          renderOptionList = _ref5.renderOptionList,
          loading = _ref5.loading;

      var mergeStyle = (cov_mo8t28n3k.s[20]++, Object.assign({}, {
        maxHeight: height,
        overflowY: 'auto'
      }, style));
      var result = (cov_mo8t28n3k.s[21]++,
      /*#__PURE__*/
      React.createElement(React.Fragment, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97,
          columnNumber: 7
        }
      }, customHeader, this.renderTree()));
      cov_mo8t28n3k.s[22]++;
      return (
        /*#__PURE__*/
        React.createElement(ScaleList, {
          getRef: getRef,
          show: focus,
          style: mergeStyle,
          "data-id": selectId,
          className: selectClass('options', 'tree'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 103,
            columnNumber: 7
          }
        }, getCustomList(result, renderOptionList, loading))
      );
    }
  }]);

  return OptionList;
}(Component);

export default OptionList;